import { render, staticRenderFns } from "./OrganizationReportsDialog.vue?vue&type=template&id=ff972b78"
import script from "./OrganizationReportsDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationReportsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports